export class InformationUrl {
  public static get GET_WORLD_TRAVEL_NEW(): string { return 'https://news.tmb.ie/NEWS/'; }
  public static get DOWNLOAD_FILE(): string { return '/api/NewMemo/download'; }

  public static get GET_MYTMB_MEMO(): string { return '/api/MasterData/mytmb-memo'}

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/information.url.ts